"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _constants = require("../constants");
var _icon_helpers = require("./icon_helpers");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var RatingMixedIcon = function RatingMixedIcon(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 20 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 20 : _ref$height,
    _ref$unselected = _ref.unselected,
    unselected = _ref$unselected === void 0 ? false : _ref$unselected;
  var strokeColor = unselected ? _icon_helpers.unselectedStrokeColor : _constants.colors.darkYellow;
  var fillColor = unselected ? _icon_helpers.unselectedFillColor : _constants.colors.veryLightYellow;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: strokeColor,
    fillRule: "nonzero",
    d: "M10 18.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17zm0 1.5C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: fillColor,
    d: "M10 18.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: strokeColor,
    fillRule: "nonzero",
    d: "M14.5 9a.75.75 0 1 1 0 1.5h-9a.75.75 0 1 1 0-1.5h9z"
  })));
};
var _default = exports["default"] = RatingMixedIcon;